import { render, staticRenderFns } from "./AddMyProducts.vue?vue&type=template&id=7eefdfe8&"
import script from "./AddMyProducts.vue?vue&type=script&lang=js&"
export * from "./AddMyProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports